import { render, staticRenderFns } from "./TContainer.vue?vue&type=template&id=d21e36fa&scoped=true&"
import script from "./TContainer.vue?vue&type=script&lang=js&"
export * from "./TContainer.vue?vue&type=script&lang=js&"
import style0 from "./TContainer.vue?vue&type=style&index=0&id=d21e36fa&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d21e36fa",
  null
  
)

export default component.exports